import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineBadge } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";

const Id = ({ values, onFileRemove, setFieldValue, setPercent, disabled }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  return (
    <div className="subscription-form--wrapper">
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.PROOF.ID.TITLE}
        subtitle={SUBSCRIPTION.FORM.PROOF.ID.SUBTITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <MdOutlineBadge size={16} key="card_membership" />
              <span className="group-label--text">
                {SUBSCRIPTION.FORM.PROOF.ADHERENT}
                <span className="label__required"> *</span>
              </span>
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                // maxCount={1}
                onUpload={(fileList) => {
                  setFieldValue("proof.cin", fileList);
                  setPercent({
                    ...values,
                    proof: { ...values.proof, cin: fileList },
                  });
                }}
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.cin", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        {!get(disabled, "proof.payerCin") && (
          <Row>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <MdOutlineBadge size={16} key="card_membership" />
                <span className="group-label--text">
                  {SUBSCRIPTION.FORM.PROOF.PAYER}
                  <span className="label__required"> *</span>
                </span>
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  // maxCount={1}
                  onUpload={(fileList) => {
                    setFieldValue("proof.payerCin", fileList);
                    setPercent({
                      ...values,
                      proof: { ...values.proof, payerCin: fileList },
                    });
                  }}
                  validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                  onFileRemove={onFileRemove}
                  fileList={get(values, "proof.payerCin", [])}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Id;
